export const apiHost = process.env.VUE_APP_BASE_API
export const apiSysHost = process.env.VUE_APP_BASE_SYS_API
export const oldVeiBanHost = process.env.VUE_APP_OLD_VEIBAN_BHOST // 老平台接口地址
export const uploadHost = process.env.VUE_APP_MINIO_ENDPOINT // 上传接口地址
export const METHOD = {
  POST: 'post',
  GET: 'get'
}